export const workEnvironment = {
  junior: {
    macos: [
      { step: 'Install Figma', command: 'brew install --cask figma' },
      { step: 'Install Sketch', command: 'brew install --cask sketch' },
      { step: 'Install Adobe Creative Cloud', command: 'brew install --cask adobe-creative-cloud' },
      { step: 'Install Slack', command: 'brew install --cask slack' },
      { step: 'Install Chrome', command: 'brew install --cask google-chrome' },
      { step: 'Install ColorSync Utility', command: 'Built-in macOS color management tool' },
      { step: 'Install Sip Color Picker', command: 'brew install --cask sip' }
    ],
    windows: [
      { step: 'Install Figma', command: 'choco install figma' },
      { step: 'Install Adobe Creative Cloud', command: 'choco install adobecreativecloud' },
      { step: 'Install Slack', command: 'choco install slack' },
      { step: 'Install Chrome', command: 'choco install googlechrome' },
      { step: 'Install Adobe XD', command: 'choco install adobexd' },
      { step: 'Install ColorPic', command: 'choco install colorpic' },
      { step: 'Install Microsoft Office', command: 'choco install office365business' }
    ],
    linux: [
      { step: 'Install Chrome', command: 'wget -q -O - https://dl.google.com/linux/linux_signing_key.pub | sudo apt-key add - && echo "deb [arch=amd64] http://dl.google.com/linux/chrome/deb/ stable main" | sudo tee /etc/apt/sources.list.d/google-chrome.list && sudo apt update && sudo apt install google-chrome-stable' },
      { step: 'Install Slack', command: 'sudo snap install slack --classic' },
      { step: 'Install GIMP', command: 'sudo apt install gimp' },
      { step: 'Install Inkscape', command: 'sudo apt install inkscape' },
      { step: 'Install Krita', command: 'sudo apt install krita' },
      { step: 'Install Gpick Color Picker', command: 'sudo apt install gpick' }
    ]
  },
  mid: {
    macos: [
      { step: 'Install Principle', command: 'brew install --cask principle' },
      { step: 'Install Zeplin', command: 'brew install --cask zeplin' },
      { step: 'Install Abstract', command: 'Web-based version control platform' },
      { step: 'Install IconJar', command: 'brew install --cask iconjar' },
      { step: 'Install CleanMyMac', command: 'brew install --cask cleanmymac' },
      { step: 'Install RapidWeaver', command: 'brew install --cask rapidweaver' }
    ],
    windows: [
      { step: 'Install Adobe After Effects', command: 'Part of Adobe Creative Cloud' },
      { step: 'Install Figma Desktop', command: 'choco install figma' },
      { step: 'Install Zeplin', command: 'choco install zeplin' },
      { step: 'Install IconEdit2', command: 'Download from official website' },
      { step: 'Install Axure RP', command: 'choco install axure-rp' },
      { step: 'Install Balsamiq Mockups', command: 'choco install balsamiq-mockups-3' }
    ],
    linux: [
      { step: 'Install Figma Web App', command: 'Create desktop shortcut for Figma web application' },
      { step: 'Install Penpot', command: 'Web-based open source design tool' },
      { step: 'Install Gravit Designer', command: 'sudo snap install gravit-designer' },
      { step: 'Install Blender', command: 'sudo snap install blender --classic' },
      { step: 'Install MyPaint', command: 'sudo apt install mypaint' }
    ]
  },
  senior: {
    macos: [
      { step: 'Install Design Operations Suite', command: 'Configure enterprise design management and workflow tools' },
      { step: 'Install Advanced Animation Tools', command: 'Set up advanced motion design and animation platforms' },
      { step: 'Install Design System Management', command: 'Configure design system governance and automation tools' },
      { step: 'Install UI Analytics Tools', command: 'Set up UI performance and user interaction analytics' }
    ],
    windows: [
      { step: 'Install Advanced Creative Suite', command: 'Configure Adobe Creative Cloud Premium features' },
      { step: 'Install Power Platform Designer', command: 'Set up Power Platform for UI automation and workflows' },
      { step: 'Install Advanced Office Suite', command: 'Configure Microsoft 365 Premium for design collaboration' },
      { step: 'Install Enterprise Design Tools', command: 'Set up enterprise UI design and management platforms' }
    ],
    linux: [
      { step: 'Install Design Infrastructure Stack', command: 'docker-compose up -d for design system and asset management' },
      { step: 'Install Advanced Open Source Suite', command: 'Set up comprehensive open source design and development tools' },
      { step: 'Install UI Automation Tools', command: 'Configure automated UI testing and design validation tools' },
      { step: 'Install Design Analytics Stack', command: 'Set up UI performance monitoring and analytics infrastructure' }
    ]
  }
};
